import * as Yup from 'yup';
export const initialSettingValues = {
    grouping: '',
    name: '',
    value: '',
};
export const settingSchema = Yup.object().shape({
    grouping: Yup.string(),
    name: Yup.string(),
    value: Yup.string(),
});
//# sourceMappingURL=settings.js.map